import React, {
  useState,
  useRef,
  useMemo,
  useCallback,
  useEffect,
} from "react";
import "../../Dashborad/dashboard.css";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import {
  adminAllConsultation,
  adminUpdateAppointmentById,
  generatePartnersXmlMeetingReport,
  getAllDocuments,
  getDoctorsByConsultationId,
  getMriDocuments,
} from "../../../config/service";
import { toast } from "react-toastify";
import ViewDocumentMeeting from "./ViewDocumentMeeting";
import Comment from "./Comment";
import MeetingUpdate from "./MeetingUpdate";
import { useTranslation } from "react-i18next";
import OfferDateModal from "./OfferDate";
import ProfileDetails from "./ProfileDetails";
import MeetingLog from "./MeetingLog";
import Report from "./Report";
import MyDoctorUpload from "./myDoctorUpload";
import AdminIdfModal from "./AdminIDFModal";
import {
  STATUS_TYPES,
  DEFAULT_OPEN,
  MEETING_GRID_FIELD_TO_SORT,
  MEETING_LIST_DEFAULT_SORT,
  MEETING_SORT_FIELD_TO_GRID_COL,
} from "./meetingDetailsConstants";
import MeetingDetailsSidebarLayout from "./MeetingDetailsSidebarLayout";
import { createDefaultColDef } from "./meetingDetailsGridConfig";
import { downloadMeetingCsvFromServer } from "./meetingDetailsCsvExport";
import { gridFilterModelToViewMeetingFilters } from "./meetingGridFilters";
import { buildMeetingColumnDefs } from "./meetingDetailsColumnDefs";
import { useMeetingListData } from "./useMeetingListData";
import MeetingDetailsToolbar from "./MeetingDetailsToolbar";
import MeetingDetailsAccordion from "./MeetingDetailsAccordion";

const MeetingDetails = ({ layout = "accordion" }) => {
  const { t } = useTranslation();
  const lang = localStorage.getItem("lang");
  const gridRef = useRef([]);
  const [id, setId] = useState();
  const [clientId, setClientId] = useState();
  const [document, setDocument] = useState([]);
  const [documentModal, setDocumentModal] = useState(false);
  const [offerModal, setOfferModal] = useState(false);
  const [offerMeetingId, setoffermeetingId] = useState();
  const [newOfferDate, setDates] = useState([]);
  const [consultId, setConsultID] = useState();
  const [mstatus, setMStatus] = useState();
  const [doctorId, setDoctorId] = useState();
  const [assapValue, setAsapValue] = useState();
  const anchorRef = useRef(null);
  const [docID, setDocID] = useState("")

  const handleCloseModal = () => (
    setOfferModal(false),
    getallmeetings(),
    setSDate(),
    setFDate(),
    setFTime(),
    setSTime(),
    setStartDate(),
    setStartDate1(),
    setDates([]),
    setConsultID()
  );

  const [fdate, setFDate] = useState();
  const [sdate, setSDate] = useState();
  const [ftime, setFTime] = useState();
  const [stime, setSTime] = useState();
  const [startDate, setStartDate] = useState(new Date());
  const [startDate1, setStartDate1] = useState(new Date());
  const [comentmeetingid, setCommentMeetingId] = useState();
  const [comment, setComment] = useState();
  const [commentModal, setCommentModal] = useState(false);
  const handleCloseComment = () => (setCommentModal(false), getallmeetings());
  const [consultData, setConsultData] = useState([]);
  const [consultfilter, setConsultfilter] = useState([]);
  const [updateId, setUpdateId] = useState();
  const [updateData, setUpdateData] = useState([]);
  const [pacseeDocument, setPacseeDocument] = useState([]);
  const [updateModal, setUpdateModal] = useState(false);
  const handleClose = () => (setUpdateModal(false), getallmeetings());
  const [priceModal, setPriceModal] = useState(false);
  const priceClose = () => (setPriceModal(false), getallmeetings());
  const [offerDates, setOfferDates] = useState([]);
  const [offerData, setofferdata] = useState([]);
  const [reqdates, setReqDates] = useState([]);
  const [reportModal, setReportModal] = useState(false);
  const [meetinglogId, setMeetinglogId] = useState();
  const [meetinglogmodal, setMeetinglogmodal] = useState(false);
  const handleMeetingLogModal = () => setMeetinglogmodal(false);
  const handleReportModalClose = () => setReportModal(false);
  const [detailsopen, setDetailsOpen] = useState(false);
  const [role, setRole] = useState();
  const [userid, setUserID] = useState();
  const [meetingKey, setMeetingKey] = useState(DEFAULT_OPEN);
  const [sidebarStatus, setSidebarStatus] = useState(DEFAULT_OPEN[0] || STATUS_TYPES[0]);
  const [checked, setChecked] = useState([]);
  const [idfModal, setIdfModal] = useState(false);
  const [myDoctorModal, setMyDoctorModal] = useState(false);
  const [showAction, setShowAction] = useState(false);
  const [selectedMeetingIds, setSelectedMeetingIds] = useState({});
  const [currentStatus, setCurrentStatus] = useState("");
  const handleDetailsClose = () => (setDetailsOpen(false), setUserID());
  const [doctorList, setDoctorList] = useState([]);
  const [meetingType, setMeetingType] = useState("");
  const [meetingSearchInput, setMeetingSearchInput] = useState("");
  const [debouncedMeetingSearch, setDebouncedMeetingSearch] = useState("");

  useEffect(() => {
    const id = setTimeout(() => setDebouncedMeetingSearch(meetingSearchInput), 300);
    return () => clearTimeout(id);
  }, [meetingSearchInput]);

  const gridApiRef = useRef({});
  const gridColumnApiRef = useRef({});
  /** Per status section: server `filters` body (from column filter UI). */
  const columnFiltersRef = useRef({});
  const columnFilterTimersRef = useRef({});
  const clearAllSelections = useCallback(() => {
    STATUS_TYPES.forEach((st) => {
      if (gridApiRef.current[st]) {
        gridApiRef.current[st].deselectAll();
      }
    });
    setSelectedMeetingIds({});
    setCurrentStatus("");
    setShowAction(false);
    setDocID("");
    setDoctorList([]);
  }, []);

  const {
    status,
    sectionLoaders,
    setOpenSections,
    loader,
    setLoader,
    allMeeting,
    setAllMeeting,
    meetingListSort,
    setMeetingListSort,
    fetchSectionData,
    getallmeetings,
    meetingDatasources,
    optimisticallyHideMeetings,
    clearHiddenMeetings,
  } = useMeetingListData({
    lang,
    clearAllSelections,
    search: debouncedMeetingSearch,
    columnFiltersRef,
    gridApiRef,
  });

  useEffect(() => {
    return () => {
      Object.values(columnFilterTimersRef.current).forEach((id) => {
        if (id) clearTimeout(id);
      });
    };
  }, []);

  const meetingListSortRef = useRef(meetingListSort);
  meetingListSortRef.current = meetingListSort;

  const getallmeetingsRef = useRef(getallmeetings);
  getallmeetingsRef.current = getallmeetings;

  useEffect(() => {
    if (docID && docID != "") {
      getDoctorList(docID)
    }
    else {
      setDoctorList([])
    }
  }, [docID])


  const handleUpdateDoctor = async (targetValue, id) => {
    const payload = { meetingIds: id, "DoctorId": targetValue }
    try {
      const response = await adminUpdateAppointmentById(payload);
      if ([200, 201, 202].includes(response.status)) {
        toast.success(response.data.msg);
        clearAllSelections(); // Clear all selections and reset state
        await getallmeetings();
      }
    } catch (error) {
      console.log(error);
    }
  };

  // Get Doc List
  const getDoctorList = async (id) => {
    try {
      const response = await getDoctorsByConsultationId(id);
      let docDetails = response.data.doctors.map(doc => {
        return {
          name: `${doc?.doctorData?.first_name} ${doc?.doctorData?.last_name}`,
          doctorId: doc?.doctorData._id
        }
      })

      setDoctorList(docDetails);
    } catch (error) {
      console.log(error);
    }
  };

  const handleIdfUpload = () => {
    setIdfModal(!idfModal);
  };
  const handleMyDoctorUpload = () => {
    setMyDoctorModal(!myDoctorModal);
  };

  const view = (id, id2, data, offerdata) => {
    const c = consultData.filter((d) => {
      return d._id == id2;
    });
    setConsultfilter(c);
    setUpdateId(id);
    setUpdateData(data);
    setofferdata(offerdata);
    setDoctorId(
      data.length != 0 && data?.DoctorId
        ? data?.DoctorId
        : data.offerDates &&
          data.offerDates.length != 0 &&
          data?.statuses !== "Scheduled"
          ? data.offerDates[0].DoctorId
          : ""
    );
    setUpdateModal(true);
  };
  const openModal = (
    id,
    dates,
    cid,
    offerdate,
    meetingstatus,
    requesteddates,
    asapvalue
  ) => {
    setoffermeetingId(id);
    setDates(dates);
    setOfferDates(offerdate);
    setConsultID(cid);
    setMStatus(meetingstatus);
    setReqDates(requesteddates);
    setAsapValue(asapvalue);
    setOfferModal(true);
  };
  const asssonpossible = (
    id,
    cid,
    offerdate,
    meetingstatus,
    requesteddates,
    asapvalue
  ) => {
    setoffermeetingId(id);
    setOfferDates(offerdate);
    setConsultID(cid);
    setMStatus(meetingstatus);
    setReqDates(requesteddates);
    setOfferModal(true);
    setAsapValue(asapvalue);
  };

  const viewComment = (id, data) => {
    setCommentMeetingId(id);
    setComment(data);
    setCommentModal(true);
  };

  const consultingFields = async () => {
    try {
      const response = await adminAllConsultation();
      setConsultData(response.data.result);
    } catch (error) {
      console.log(error);
    }
  };
  const allDocument = async (id) => {
    try {
      const response = await getAllDocuments(id);

      if ([200, 201, 202].includes(response.data.code)) {
        setDocument(response.data.meetingDocuments);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const viewDocument = async (id, id2, data) => {
    setMeetingType(data?.meetingType);
    setId(id);
    setClientId(id2);
    setDocumentModal(true);
    allDocument(id);
    mridocument(id);
  };
  const mridocument = async (id) => {
    try {
      const response = await getMriDocuments(id);
      setPacseeDocument(response.data.pacseeFiles);
    } catch (error) {
      console.log(error);
    }
  };
  const handleChangestatus = (event, id, oldStatus) => {
    let targetValue = event.target.value;
    statusUpload(targetValue, id, oldStatus);
  };
  const statusUpload = async (targetValue, id, oldStatus) => {
    if (oldStatus) optimisticallyHideMeetings([id], oldStatus);

    const data = {
      statuses: targetValue,
      meetingIds: [id],
    };
    try {
      const response = await adminUpdateAppointmentById(data);
      clearHiddenMeetings([id]);
      if ([200, 201, 202].includes(response.status)) {
        toast.success(response.data.msg);
        if (oldStatus) fetchSectionData(oldStatus);
        if (targetValue) fetchSectionData(targetValue);
      } else {
        if (oldStatus) fetchSectionData(oldStatus);
      }
    } catch (error) {
      console.log(error);
      clearHiddenMeetings([id]);
      if (oldStatus) fetchSectionData(oldStatus);
    }
  };
  const meetinglog = (id) => {
    setMeetinglogId(id);
    setMeetinglogmodal(true);
  };

  const cellClickedListener = useCallback(() => undefined, []);

  useEffect(() => {
    consultingFields();
  }, []);

  useEffect(() => {
    getallmeetingsRef.current(STATUS_TYPES);
  }, [allMeeting, debouncedMeetingSearch]);
  const rowClassRules = useMemo(() => ({
    "admin-prescription-only": (params) => {
      if (!params?.data?.data) return false;
      const status = params.data.data.statuses;
      const type = params.data.data.meetingType;
      return status === "Done" && type === "PrescriptionOnly";
    },
  }), []);
  const UpdateDetails = async (checkedValue, meetingid) => {
    const data = {
      isNotification: checkedValue,
      meetingIds: [meetingid],
    };
    try {
      const response = await adminUpdateAppointmentById(data);
      if ([200, 201, 202].includes(response.status)) {
        toast.success(t(response.data.msg));
        handleClose();
      }
    } catch (error) {
      console.log(error);
    }
  };
  const handleMeetingListFilterChanged = useCallback(
    (event, statusType) => {
      const prev = columnFilterTimersRef.current[statusType];
      if (prev) clearTimeout(prev);
      columnFilterTimersRef.current[statusType] = setTimeout(() => {
        columnFilterTimersRef.current[statusType] = null;
        const model = event.api.getFilterModel();
        const next = gridFilterModelToViewMeetingFilters(model);
        columnFiltersRef.current[statusType] = next;
        fetchSectionData(statusType);
      }, 400);
    },
    [fetchSectionData]
  );

  const handleMeetingListSortChanged = useCallback(
    (event) => {
      const columnState =
        typeof event?.columnApi?.getColumnState === "function"
          ? event.columnApi.getColumnState()
          : [];
      const cols = columnState.filter((c) => c.sort != null);
      if (cols.length === 0) {
        setMeetingListSort((prev) =>
          prev.sortField === MEETING_LIST_DEFAULT_SORT.sortField &&
          prev.sortDir === MEETING_LIST_DEFAULT_SORT.sortDir
            ? prev
            : { ...MEETING_LIST_DEFAULT_SORT }
        );
        return;
      }
      const primary = [...cols].sort(
        (a, b) => (a.sortIndex ?? 0) - (b.sortIndex ?? 0)
      )[0];
      const apiField = MEETING_GRID_FIELD_TO_SORT[primary.colId];
      if (!apiField) return;
      const sortDir = primary.sort === "asc" ? 1 : -1;
      setMeetingListSort((prev) =>
        prev.sortField === apiField && prev.sortDir === sortDir
          ? prev
          : { sortField: apiField, sortDir }
      );
    },
    [setMeetingListSort]
  );

  useEffect(() => {
    const colId = MEETING_SORT_FIELD_TO_GRID_COL[meetingListSort.sortField];
    if (!colId) return;
    const sort = meetingListSort.sortDir === 1 ? "asc" : "desc";
    STATUS_TYPES.forEach((st) => {
      const columnApi = gridColumnApiRef.current[st];
      if (!columnApi?.applyColumnState) return;
      columnApi.applyColumnState({
        state: [{ colId, sort, sortIndex: 0 }],
        defaultState: { sort: null },
      });
    });
  }, [meetingListSort]);

  const onGridReady = useCallback((params, statusType) => {
    gridApiRef.current[statusType] = params.api;
    gridColumnApiRef.current[statusType] = params.columnApi;
    const ms = meetingListSortRef.current;
    const colId = MEETING_SORT_FIELD_TO_GRID_COL[ms.sortField];
    if (colId && params.columnApi?.applyColumnState) {
      params.columnApi.applyColumnState({
        state: [
          {
            colId,
            sort: ms.sortDir === 1 ? "asc" : "desc",
            sortIndex: 0,
          },
        ],
        defaultState: { sort: null },
      });
    }
    if (window.innerWidth < 991) {
      params.api.sizeColumnsToFit();
    }
  }, []);
  const onExportClick = useCallback(async () => {
    const sections = checked.filter((el) => status.some((s) => s.type === el));
    if (sections.length === 0) {
      setChecked([]);
      return;
    }
    setLoader(true);
    try {
      const mergedFilters = sections.reduce((acc, el) => {
        const f = columnFiltersRef.current[el];
        if (f && Object.keys(f).length > 0) {
          Object.entries(f).forEach(([k, v]) => {
            if (v != null && v !== "") acc[k] = v;
          });
        }
        return acc;
      }, {});

      await downloadMeetingCsvFromServer({
        statusTypes: sections,
        allMeeting,
        search: debouncedMeetingSearch,
        lang,
        sortField: meetingListSort.sortField,
        sortDir: meetingListSort.sortDir,
        filters: Object.keys(mergedFilters).length > 0 ? mergedFilters : undefined,
      });
      setChecked([]);
    } catch (e) {
      console.log(e);
      toast.error("Export failed");
    } finally {
      setLoader(false);
    }
  }, [
    checked,
    status,
    allMeeting,
    debouncedMeetingSearch,
    lang,
    setLoader,
    meetingListSort,
  ]);

  const handleSelectDownload = (type) => {
    setChecked((prevSelected) => {
      const newArray = [...prevSelected];
      if (newArray.includes(type)) {
        return newArray.filter((item) => item != type);
      } else {
        newArray.push(type);
        return newArray;
      }
    });
  };

  const handleAccordionSelect = (activeKeys) => {
    const activeSet = new Set(activeKeys || []);
    const prevSet = new Set(meetingKey);

    activeSet.forEach((key) => {
      if (!prevSet.has(key)) {
        const section = status.find((s) => s.type === key);
        if (!section || section.meetings.length === 0) {
          fetchSectionData(key);
        }
      }
    });

    setMeetingKey(activeKeys || []);
    setOpenSections(activeSet);
  };

  const handleRefreshSection = (statusType) => {
    fetchSectionData(statusType);
  };

  const handleSidebarStatusSelect = (type) => {
    setSidebarStatus(type);
    const section = status.find((s) => s.type === type);
    if (!section || section.meetings.length === 0) {
      fetchSectionData(type);
    }
    setOpenSections((prev) => new Set(prev).add(type));
  };

  const handleGeneratePartnersXmlReport = async (meetingId) => {
    const data = {
      meetingId: meetingId,
    };

    try {
      const response = await generatePartnersXmlMeetingReport(data);

      const { status } = response;

      if (status === 201) {
        if (response.data.message) {
          toast.error(t(response.data.message));
        } else {
          const outputFilename = `${meetingId}-Ichilov.xml`;
          downloadXmlFile(response.data, outputFilename);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const downloadXmlFile = (xmlData, outputFilename) => {
    const blob = new Blob([xmlData], { type: "text/xml" });
    const url = window.URL.createObjectURL(blob);
    anchorRef.current.href = url;
    anchorRef.current.setAttribute("download", outputFilename);
    anchorRef.current.click();
    window.URL.revokeObjectURL(url);
  };

  const defaultColDef = useMemo(() => createDefaultColDef(), []);

  const meetingStatusDropdownOptions = useMemo(
    () => STATUS_TYPES.map((t) => ({ type: t })),
    []
  );

  const columnDefsMap = useMemo(() => {
    const map = {};
    STATUS_TYPES.forEach((type) => {
      map[type] = buildMeetingColumnDefs({
        currentStatus,
        statusType: type,
        status: meetingStatusDropdownOptions,
        setDetailsOpen,
        setRole,
        setUserID,
        handleChangestatus,
        viewComment,
        viewDocument,
        view,
        openModal,
        asssonpossible,
        UpdateDetails,
        meetinglog,
        handleGeneratePartnersXmlReport,
      });
    });
    return map;
  }, [currentStatus, meetingStatusDropdownOptions]);

  const onSelectionChanged = (event, statusType) => {

    const selectedNodes = event.api.getSelectedNodes();
    const selectConsultationId = selectedNodes.map((node) => node.data?.data?.consultation?._id);
    const allSame = selectConsultationId.every(item => item === selectConsultationId[0]);

    const selectedIds = selectedNodes.map((node) => node.data?.data?._id);

    // If selecting from a different status type, clear previous selections from other grids
    if (currentStatus && currentStatus !== statusType) {
      // Clear selections from all other grids
      Object.keys(gridApiRef.current).forEach((key) => {
        if (key !== statusType) {
          gridApiRef.current[key].deselectAll();
        }
      });
      // Reset and start fresh with new status type
      setCurrentStatus(statusType);
      setDocID(allSame ? selectConsultationId[0] : "");
      setSelectedMeetingIds({
        meetingIds: selectedIds,
      });
    } else {
      // Same status type, update normally
      setDocID(allSame ? selectConsultationId[0] : "");
      setSelectedMeetingIds((prevSelectedIds) => ({
        ...prevSelectedIds,
        meetingIds: selectedIds,
      }));
      setCurrentStatus(statusType);
    }

    // Show/hide bulk actions based on selection
    if (selectedIds.length > 0) {
      setShowAction(true);
    } else {
      setShowAction(false);
      setCurrentStatus(null);
      setDocID("");
    }
  };

  const handleBulkUpdate = async (targetStatus) => {
    const ids = selectedMeetingIds.meetingIds || [];
    const fromStatus = currentStatus;
    if (fromStatus) optimisticallyHideMeetings(ids, fromStatus);
    clearAllSelections();

    const data = {
      statuses: targetStatus,
      meetingIds: ids,
    };
    try {
      setLoader(true);
      const response = await adminUpdateAppointmentById(data);
      clearHiddenMeetings(ids);
      if ([200, 201, 202].includes(response.status)) {
        if (fromStatus) fetchSectionData(fromStatus);
        if (targetStatus) fetchSectionData(targetStatus);
        if (response?.data?.message === "Partial success") {
          toast.warning(t("Could not change status of all selected meetings"), {
            toastId: "warning",
          });
        } else {
          toast.success(response?.data?.message, { toastId: "success" });
        }
        setLoader(false);
      }
    } catch (error) {
      console.log(error);
      clearHiddenMeetings(ids);
      if (fromStatus) fetchSectionData(fromStatus);
      clearAllSelections();
      setLoader(false);
      toast.error(error?.response?.data?.message, { toastId: "error" });
    }
  };

  return (
    <>
      <a ref={anchorRef} style={{ display: "none" }} />
      <ProfileDetails
        detailsopen={detailsopen}
        role={role}
        userid={userid}
        handleDetailsClose={handleDetailsClose}
      />
      <OfferDateModal
        offerModal={offerModal}
        offerMeetingId={offerMeetingId}
        handleCloseModal={handleCloseModal}
        newOfferDate={newOfferDate}
        fdate={fdate}
        setFDate={setFDate}
        sdate={sdate}
        setSDate={setSDate}
        ftime={ftime}
        setFTime={setFTime}
        stime={stime}
        setSTime={setSTime}
        startDate={startDate}
        setStartDate={setStartDate}
        startDate1={startDate1}
        setStartDate1={setStartDate1}
        consultId={consultId}
        offerDates={offerDates}
        mstatus={mstatus}
        requestedDates={reqdates}
        assapValue={assapValue}
      />
      {meetinglogmodal && (
        <MeetingLog
          handleClose={handleMeetingLogModal}
          meetinglogModal={meetinglogmodal}
          meetingId={meetinglogId}
        />
      )}
      <Comment
        comentmeetingid={comentmeetingid}
        comment={comment}
        commentModal={commentModal}
        handleClose={handleCloseComment}
      />
      {id && documentModal && (
        <ViewDocumentMeeting
          documentModal={documentModal}
          document={document}
          setDocumentModal={setDocumentModal}
          meetingid={id}
          clientId={clientId}
          pacseeDocument={pacseeDocument}
          setPacseeDocument={setPacseeDocument}
          meetingType={meetingType}
        />
      )}
      <MeetingUpdate
        consultfilter={consultfilter}
        updateId={updateId}
        updateData={updateData}
        updateModal={updateModal}
        setUpdateModal={setUpdateModal}
        handleClose={handleClose}
        consultData={consultData}
        priceClose={priceClose}
        priceModal={priceModal}
        setPriceModal={setPriceModal}
        offerDates={offerData}
        doctorId={doctorId}
        setDoctorId={setDoctorId}
        refetchAllmeetings={getallmeetings}
        allMeetingData={status}
        setUpdateData={setUpdateData}
      />
      <Report
        handleReportModalClose={handleReportModalClose}
        reportModal={reportModal}
      />
      {idfModal && (
        <AdminIdfModal
          idfModal={idfModal}
          handleIdfUpload={handleIdfUpload}
          getallmeetings={getallmeetings}
        />
      )}
      {myDoctorModal && (
        <MyDoctorUpload
          myDoctorModal={myDoctorModal}
          setMyDoctorModal={setMyDoctorModal}
          handleMyDoctorUpload={handleMyDoctorUpload}
        />
      )}

      <div
        className="adminDataTable"
      // style={{ paddingTop: "13%", background: "#f1f1f1" }}
      >
        <MeetingDetailsToolbar
          status={status}
          checked={checked}
          loader={loader}
          allMeeting={allMeeting}
          showAction={showAction}
          currentStatus={currentStatus}
          lang={lang}
          doctorList={doctorList}
          selectedMeetingIds={selectedMeetingIds}
          onOpenReport={() => setReportModal(true)}
          onSelectExportSection={handleSelectDownload}
          onExportDownload={onExportClick}
          onAllMeetingChange={setAllMeeting}
          onIdfClick={handleIdfUpload}
          onMyDoctorClick={handleMyDoctorUpload}
          onBulkStatusChange={handleBulkUpdate}
          onUpdateDoctor={handleUpdateDoctor}
          filterValue={meetingSearchInput}
          onFilterChange={(e) => setMeetingSearchInput(e.target.value)}
        />

        {layout === "sidebar" ? (
          <MeetingDetailsSidebarLayout
            status={status}
            selectedType={sidebarStatus}
            onSelectStatus={handleSidebarStatusSelect}
            sectionLoaders={sectionLoaders}
            meetingDatasources={meetingDatasources}
            gridRef={gridRef}
            columnDefsMap={columnDefsMap}
            defaultColDef={defaultColDef}
            cellClickedListener={cellClickedListener}
            onGridReady={onGridReady}
            rowClassRules={rowClassRules}
            onSelectionChanged={onSelectionChanged}
            onRefreshSection={handleRefreshSection}
            onSortChanged={handleMeetingListSortChanged}
            onFilterChanged={handleMeetingListFilterChanged}
          />
        ) : (
          <MeetingDetailsAccordion
            status={status}
            sectionLoaders={sectionLoaders}
            meetingDatasources={meetingDatasources}
            onAccordionSelect={handleAccordionSelect}
            gridRef={gridRef}
            columnDefsMap={columnDefsMap}
            defaultColDef={defaultColDef}
            cellClickedListener={cellClickedListener}
            onGridReady={onGridReady}
            rowClassRules={rowClassRules}
            onSelectionChanged={onSelectionChanged}
            onSortChanged={handleMeetingListSortChanged}
            onFilterChanged={handleMeetingListFilterChanged}
            onRefreshSection={handleRefreshSection}
          />
        )}
      </div>
    </>
  );
};

export default MeetingDetails;

export { ageCalculator } from "./meetingDetailsUtils";
